import { startWith, map, flatMap } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { CompanysitesService } from '../../company-sites/company-sites.service';
import { SystemService } from '../../../services/system.service';


@Component({
  selector: 'app-records',
  templateUrl: './records.component.html',
  styleUrls: ['./records.component.css']
})
export class RecordsComponent implements OnInit {

  layoutSetup: Observable<any>;
  siteId;
  systemId;
  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    let siteIdObs = this.route.params.pipe(map(params => {
      this.systemId = params['siteId'];
      this.siteId = params['siteId'];
      return {
        siteId: params['siteId'],
        systemId: params['systemId']
      };
    }));

    this.layoutSetup = combineLatest(siteIdObs).pipe(map(values => {
      return {
        links: [
          // { name: "RFID Logs", path: "/dashboard/sites/" + values[0].siteId + "/system/" + values[0].systemId + "/records" + "/rfidlogs" },
          { name: "Transactions", path: "/dashboard/sites/" + values[0].siteId + "/system/" + values[0].systemId + "/records" + "/transactions" },
          { name: "Action log", path: "/dashboard/sites/" + values[0].siteId + "/system/" + values[0].systemId + "/records" + "/actions" },
          { name: "Machine log", path: "/dashboard/sites/" + values[0].siteId + "/system/" + values[0].systemId + "/records" + "/machinelogs" }

        ]

      };
    }));
  }

}
